import type { Control, FieldValues } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FlatRowFormDatePicker } from "web_myplann/Shared/Components/FlatRow/FlatRowFormDatePicker";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { DateView } from "web_myplann/Shared/Types/DateView";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

type Props = {
	control: Control<FieldValues>;
	isLast?: boolean;
};

const PageResources = Resources.Portfolio.AddTools;

export const ToolValueFields = ({ control, isLast }: Props) => {
	const { t } = useResource();

	return (
		<>
			<FlatRowFormInput
				control={control}
				name="invested"
				type="number"
				label={t(PageResources.Fields.invested)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix={t(Resources.Common.CurrencySign)}
			/>
			<FlatRowFormInput
				control={control}
				name="value"
				type="number"
				label={t(PageResources.Fields.value)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix={t(Resources.Common.CurrencySign)}
			/>
			<FlatRowFormDatePicker
				control={control}
				name="valueDate"
				label={t(PageResources.Fields.valueDate)}
				views={[DateView.Year, DateView.Month, DateView.Day]}
				displayFormat={DateFormat.Display}
				maxDate={new Date()}
				isLast={isLast}
			/>
		</>
	);
};
